export default __webpack_public_path__ + "static/media/mrpanda.868a494c.png";